<template>
  <default-layout>
    <div>
      <applicant-details></applicant-details>
    </div>
  </default-layout>
</template>

<script>
import ApplicantDetails from '../components/applications/ApplicantDetails.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'

export default {
  components: {
    DefaultLayout,
    ApplicantDetails
  }
}
</script>
